import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { useMenuDispatcher } from '../menuContext';
import { NavigationItemLinkModel } from './navigationItem/models/navigationItem.model';
import RoutableSitecoreLink from '../../@shared/routableSitecoreLink';
import { googleClickNavEvent } from '../../../utils/analytics';

const NavigationItemLink = ({ model }: { model: NavigationItemLinkModel }) => {
  const linkField = model.link;
  const textField = model.menuTitle;

  const dispatchToProvider = useMenuDispatcher();
  const handleClick = () => {
    dispatchToProvider({ type: 'closeAll' });
    googleClickNavEvent('Global Nav', model?.displayName, model?.displayName);
  };
  return (
    <li className="navigation__menu-item">
      <RoutableSitecoreLink field={linkField} onClick={handleClick} className="navigation__menu-item__trigger">
        <RichText tag="span" className="navigation__menu-item__trigger__content rich-text" field={textField} />
      </RoutableSitecoreLink>
    </li>
  );
};

export default NavigationItemLink;
